import * as Types from '../../declarations'
// import PictureGrid from './components/PictureGrid'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const History = ({
	trip: {
		name,
		jsonData: { history },
	},
}: // trip,
Props) => {
	if (!history) return <></>

	// const defaultAltText = getTrekImageAltText(trip, 'getting there')

	return (
		<div id="history-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} History`}
				subtitle={`Climbing history of ${name}`}
				section={Types.App.DataTypes.FeedbackSection.HISTORY}
			/>
			{!!history && (
				<HTMLContent id="history-description" html={history}></HTMLContent>
			)}
		</div>
	)
}

export default History
